<template>
    <div class="zp-main">
        <div class="zp-content">

            <el-row>
                <el-col style="margin: 15px;">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/recruit/list' }"><i class="el-icon-menu"></i> 校园招聘
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>投递简历</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <div style="width: 960px; margin: 30px auto;">
                <el-row :gutter="120">
                    <el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="120px">
                        <el-col :span="12">
                            <el-form-item label="姓 名" prop="a0101">
                                <el-input v-model="formData.a0101" placeholder="请输入姓名" clearable
                                          suffix-icon='el-icon-user'
                                          :style="{width: '100%'}"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="年 龄" prop="age">
                                <el-input v-model="formData.age" placeholder="请输入年龄" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="性 别" prop="a0102">
                                <el-radio-group v-model="formData.a0102" size="small">
                                    <el-radio-button v-for="(item, index) in a0102Options" :key="index"
                                                     :label="item.value"
                                                     :disabled="item.disabled" border>{{item.label}}
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="籍 贯" prop="originplace">
                                <el-input v-model="formData.originplace" placeholder="请输入籍贯" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="邮 箱" prop="email">
                                <el-input v-model="formData.email" placeholder="请输入邮箱" clearable
                                          :style="{width: '100%'}">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话" prop="a0118">
                                <el-input v-model="formData.a0118" placeholder="请输入联系电话" :maxlength="11" show-word-limit
                                          clearable
                                          prefix-icon='el-icon-mobile' :style="{width: '100%'}"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="期望工作地点" prop="a0202">
                                <el-select v-model="formData.a0202Aarry" placeholder="请选择期望工作地点（可多选）" filterable clearable
                                           multiple
                                           :style="{width: '100%'}">
                                    <el-option v-for="(item, index) in a0202Options" :key="index" :label="item.MC0000"
                                               :value="item.BM0000" :disabled="item.disabled"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最高学历" prop="a0124">
                                <el-select v-model="formData.a0124" placeholder="请选择最高学历" filterable clearable
                                           :style="{width: '100%'}">
                                    <el-option v-for="(item, index) in a0124Options" :key="index" :label="item.MC0000"
                                               :value="item.BM0000" :disabled="item.disabled"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="院校所属省份" prop="zpresumeinfo003">
                                <el-select v-model="formData.zpresumeinfo003" placeholder="请选择院校所属省份" filterable
                                           clearable
                                           :style="{width: '100%'}">
                                    <el-option v-for="(item, index) in zpresumeinfo003Options" :key="index"
                                               :label="item.MC0000"
                                               :value="item.BM0000" :disabled="item.disabled"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="毕业院校" prop="univiersity">
                                <el-input v-model="formData.univiersity" placeholder="请输入毕业院校" clearable
                                          :style="{width: '100%'}">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="专 业" prop="trade">
                                <el-input v-model="formData.trade" placeholder="请输入专业" clearable
                                          :style="{width: '100%'}">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否服从调剂" prop="zpresumeinfo001">
                                <el-radio-group v-model="formData.zpresumeinfo001" size="small">
                                    <el-radio-button v-for="(item, index) in zpresumeinfo001Options" :key="index"
                                                     :label="item.value" :disabled="item.disabled">{{item.label}}
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="高考成绩" prop="zpresumeinfo002">
                                <el-input v-model="formData.zpresumeinfo002" placeholder="请输入高考成绩" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="上传" prop="a0123">
                                <el-upload ref="a0123" :action="a0123Action"
                                           :headers="config"
                                           name="fileList"
                                           :multiple="multiple"
                                           :limit="1"
                                           :on-success="handle_success"
                                           :before-upload="a0123BeforeUpload" accept=".pdf,.docx,.doc">
                                    <el-button size="small" type="primary" icon="el-icon-upload">上传附件简历</el-button>
                                    <div slot="tip" class="el-upload__tip">只能上传pdf | word文件，且不超过4M</div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" style="margin-top: 20px;">
                            <el-form-item size="large">
                                <el-button type="primary" @click="submitForm">提交</el-button>
                                <el-button @click="resetForm">重置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
            </div>

        </div>
    </div>
</template>

<script>
    import * as u from '@/util/util'

    export default {
        name: "zp_submit_resume",
        data() {
            return {
                //props:['id'],
                formData: {
                    a0101: undefined,
                    age: undefined,
                    a0102: undefined,
                    originplace: undefined,
                    email: undefined,
                    a0118: undefined,
                    a0202: undefined,
                    a0124: undefined,
                    zpresumeinfo003: undefined,
                    univiersity: undefined,
                    trade: undefined,
                    zpresumeinfo001: undefined,
                    zpresumeinfo002: undefined,
                    a0123: undefined,
                    position: undefined
                },
                rules: {
                    a0101: [{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur'
                    }],
                    age: [{
                        required: true,
                        message: '请输入年龄',
                        trigger: 'blur'
                    }],
                    a0102: [{
                        required: true,
                        message: '性别不能为空',
                        trigger: 'change'
                    }],
                    originplace: [{
                        required: true,
                        message: '请输入籍贯',
                        trigger: 'blur'
                    }],
                    email: [
                        {required: true, message: '请输入邮箱', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur'},
                    ],
                    a0118: [{
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                    }, {
                        pattern: /^1(3|4|5|7|8|9)\d{9}$/,
                        message: '请输入正确的手机号',
                        trigger: 'blur'
                    }],
                    a0202: [{
                        required: true,
                        message: '请选择期望工作地点',
                        trigger: 'change'
                    }],
                    a0124: [{
                        required: true,
                        message: '请选择最高学历',
                        trigger: 'change'
                    }],
                    a0202: [{
                        required: true,
                        message: '请选择期望工作地点',
                        trigger: 'change'
                    }],
                    zpresumeinfo003: [{
                        required: true,
                        message: '请选择院校所属省份',
                        trigger: 'change'
                    }],
                    univiersity: [{
                        required: true,
                        message: '请输入毕业院校',
                        trigger: 'blur'
                    }],
                    trade: [{
                        required: true,
                        message: '请输入专业',
                        trigger: 'blur'
                    }],
                    zpresumeinfo001: [{
                        required: true,
                        message: '是否服从调剂不能为空',
                        trigger: 'change'
                    }],
                    zpresumeinfo002: [{
                        required: true,
                        message: '请输入高考成绩',
                        trigger: 'blur'
                    }],
                    a0123: [{
                        required: true,
                        message: '请上传附件简历',
                        trigger: 'blur'
                    }],
                },
                a0123Action: 'http://zhaopin.woer.com:8117/zp-resume/ftpUpload',
                token: "",
                multiple: false,
                a0102Options: [{
                    "label": "男",
                    "value": 1
                }, {
                    "label": "女",
                    "value": 2
                }],
                a0202Options: [],
                a0124Options: [],
                zpresumeinfo003Options: [],
                zpresumeinfo001Options: [{
                    "label": "是",
                    "value": 1
                }, {
                    "label": "否",
                    "value": 2
                }],
            }
        },
        computed: {
            config() {
                return {
                    "X-Access-Token": this.token
                };
            }
        },
        watch: {
            'formData.a0202Aarry': {
                handler: function(newValue, oldValue) {
                    this.formData.a0202 = newValue.join(',')
                }
            }
        },
        created() {
            //this.formData.position = this.$route.query.position;
            this.formData.position = this.$route.params.id;
            this.getA0124Options();
            this.getA0202Options();
            this.getZpresumeinfo003Options();
        },
        mounted() {
            debugger;
            this.token = u.getToken();
        },
        methods: {
            submitForm() {
                debugger;
                this.$refs['elForm'].validate(valid => {
                    if (!valid) return
                    // TODO 提交表单
                    console.log(this.formData);
                    this.$HttpService.post('/zp-resume/submit-resume', this.formData).then(res => {
                        this.$message.success('新增成功');
                        this.$router.push("/")
                    }).catch(() => {

                    })
                })
            },
            handle_success(res) {
                console.log(res)
                this.formData.a0123 = res;
                this.$message.success('图片上传成功')
            },
            resetForm() {
                this.$refs['elForm'].resetFields()
            },
            a0123BeforeUpload(file) {
                let isRightSize = file.size / 1024 / 1024 < 4
                if (!isRightSize) {
                    this.$message.error('文件大小超过 4MB')
                }
                let isAccept = new RegExp('.pdf|.docx|.doc').test(file.type)
                if (!isAccept) {
                    this.$message.error('应该选择.pdf|.docx|.doc类型的文件')
                }
                return isRightSize && isAccept
            },
            getA0202Options() {//期望工作地点
                this.$HttpService.get('/zp-resume/get-bm-qwfzdd').then(res => {
                    console.log(res);
                    this.a0202Options = res;
                }).catch(() => {

                })
            },
            getA0124Options() {//学历
                this.$HttpService.get('/zp-resume/get-bm-xl').then(res => {
                    console.log(res);
                    this.a0124Options = res;
                }).catch(() => {

                })
            },
            getZpresumeinfo003Options() {//院校所属省份
                this.$HttpService.get('/zp-resume/get-bm-wryxsf').then(res => {
                    console.log(res);
                    this.zpresumeinfo003Options = res;
                }).catch(() => {

                })
            }
        }
    }

</script>
<style scoped>
    .zp-content {
        margin: auto;
        height: 760px;
        width: 1500px;
        padding: 8px;
        background-color: #FFF;
        border-radius: 4px;
    }
</style>